import { useEffect, useState } from 'react';
import { CalibratedTool } from '../../shared/types/calibratedTool.ts';
import { trpc } from '../utils/trpc/trpc.ts';
import { ModalSubmitDialog } from './modalSubmitDialog.tsx';
import { ToggleButton } from './toggleButton.tsx';


interface Props {
    isOpen: boolean;
    initialSelection?: string[];
    onCancel: () => void;
    onSubmit: (selectedTools: string[]) => void;
}

export function CalibratedToolDialog({
    isOpen,
    initialSelection,
    onCancel,
    onSubmit,
}: Props) {
    const [selectedTools, setSelectedTools] = useState<string[]>(initialSelection ?? []);


    const { data: calibratedTools, error, isLoading } = trpc.calibratedTools.get.useQuery({
        isEnabled: true,
    }, {
        select: (data: CalibratedTool[]) => [...data].sort((a, b) => a.name.localeCompare(b.name)),
    });


    useEffect(() => {
        if (isOpen) setSelectedTools(initialSelection ?? []);
    }, [initialSelection, isOpen])


    function handleSelectToggle(tool: CalibratedTool) {
        handleSelectChange(tool, !isSelected(tool));
    }

    function handleSelectChange(tool: CalibratedTool, isSelected: boolean) {
        if (isSelected) {
            setSelectedTools(Array.from(new Set([...selectedTools, tool.serialNumber])));
        } else {
            setSelectedTools(selectedTools.filter(it => it !== tool.serialNumber));
        }
    }

    function isSelected(tool: CalibratedTool): boolean {
        return selectedTools.some(it => it === tool.serialNumber);
    }

    function handleSubmit() {
        return onSubmit(selectedTools);
    }


    if (!isOpen) return null;
    return (
        <ModalSubmitDialog isOpen={isOpen} onCancel={onCancel} onSubmit={handleSubmit}>
            {error && <p>error</p>}
            {isLoading && <p>Loading...</p>}
            {calibratedTools &&
                <table className='table--calibrated-tools'>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Serial number</th>
                            <th>Type</th>
                            <th>Is selected</th>
                        </tr>
                    </thead>
                    <tbody>
                        {calibratedTools?.map(it => (
                            <tr key={it.serialNumber} onClick={() => handleSelectToggle(it)}>
                                <td>{it.name}</td>
                                <td>{it.serialNumber}</td>
                                <td>{it.type}</td>
                                <td>
                                    <ToggleButton
                                        selection={isSelected(it)}
                                        onSelectionChange={(isSelected) => handleSelectChange(it, isSelected)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            }
        </ModalSubmitDialog>
    )
}

